module.exports = __webpack_public_path__ + "static/assets/a9dd1477f22d75060a8c3ef1fa06b3eb.png";